import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "list"
}
const _hoisted_2 = { class: "text" }
const _hoisted_3 = {
  key: 1,
  class: "list"
}
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['progress-bar', `progress-bar-${_ctx.type}`, `progress-bar-${_ctx.skin}`])
  }, [
    (_ctx.type === 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["item", {
            current: item.minPageNum <= _ctx.current && _ctx.current <= item.maxPageNum,
            done: _ctx.current > item.maxPageNum,
          }]),
              key: index
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(item.text), 1),
              _cache[0] || (_cache[0] = _createElementVNode("em", { class: "line" }, null, -1))
            ], 2))
          }), 128))
        ]))
      : (_ctx.type === 1)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["item", { current: _ctx.current === index, done: _ctx.current > index }]),
                key: index
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(item.text), 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(item.desc), 1),
                _cache[1] || (_cache[1] = _createElementVNode("em", { class: "line" }, null, -1))
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true)
  ], 2))
}